const channel = new BroadcastChannel('redux_sync_channel')

export const broadcastMiddleware = () => next => action => {
    if (action.meta && action.meta.fromBroadcast) {
        return next(action)
    }

    if (action.meta && action.meta.noBroadcast) {
        return next(action)
    }

    try {
        const json = JSON.parse(JSON.stringify(action))
        channel.postMessage(json)
    } catch (e) {
        console.log('broadcastMiddleware', e)
    }

    return next(action)
}

export const initBroadcastListener = (store) => {
    channel.onmessage = (event) => {
        const action = event.data

        store.dispatch({
            ...action,
            meta: { ...action.meta, fromBroadcast: true }
        })
    }
}